import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getTrainingCapabilities } from '../api';
import { isSafeUrl } from './urls';

// The server only ever stores absolute http(s) links, but the button renders an
// anchor, so re-check (via ./urls) rather than trust the payload.

// Per-class link into the LMS. Renders nothing when the class has no
// destination yet, so a half-configured catalog never shows a dead button.
export function LmsButton({ url, label = 'Go to the LMS', className = '' }) {
  if (!isSafeUrl(url)) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-sm font-bold px-3 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 ${className}`}
    >
      {label}
    </a>
  );
}

// Standing "take your training" section at the top of My Classes. Uses the
// global portal URL the Training Director sets in Admin, not a per-class link.
export default function LmsCard() {
  const { data } = useQuery({ queryKey: ['training-me'], queryFn: getTrainingCapabilities });
  const url = data?.lms?.url;
  const note = data?.lms?.note;
  if (!isSafeUrl(url)) return null;

  return (
    <div className="rounded-xl border border-blue-200 dark:border-blue-900 bg-blue-50 dark:bg-blue-950/40 p-4 flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-0">
        <div className="text-sm font-bold text-blue-900 dark:text-blue-200">Take your training</div>
        <p className="text-xs text-blue-800/80 dark:text-blue-300/80 mt-0.5">
          {note || 'Your classes run in Zeffert University. Open the LMS to start or continue a course.'}
        </p>
      </div>
      <LmsButton url={url} label="Open the LMS" />
    </div>
  );
}
